var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex-column sopimus-card-container"},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"d-flex"},[_vm._t("content")],2)],1),_c('b-row',[_c('b-col',[_vm._t("button")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }